import React, { useState } from "react";
import SelectExelRows from "./SelectExelRows"; // Import the next step

function UploadExel({ width, onFileSelect, onSelectionsChange, onUnitChange }) {
  const uploadBoxHeight = width / 3; // Set the height of the upload field
  const [dragActive, setDragActive] = useState(false);
  const [selectedExcelFile, setSelectedExcelFile] = useState(null); // ✅ Unique state for Excel
  const [errorExcel, setErrorExcel] = useState(""); // ✅ Unique error state for Excel

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = () => {
    setDragActive(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragActive(false);
    if (event.dataTransfer.files.length > 0) {
      validateFile(event.dataTransfer.files[0]);
    }
  };

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      validateFile(event.target.files[0]);
    }
  };

  const openFileDialog = () => {
    document.getElementById(`fileInput-excel-${width}`).click(); // ✅ Unique ID
  };

  const validateFile = (file) => {
    const validFileTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-excel", // .xls
      "text/csv" // .csv
    ];
  
    if (validFileTypes.includes(file.type) || file.name.endsWith(".csv")) { // ✅ Accept CSVs by name check
      setSelectedExcelFile(file);
      setErrorExcel(""); 
      onFileSelect && onFileSelect(file); // ✅ Return file to parent
    } else {
      setSelectedExcelFile(null);
      setErrorExcel("Please select an Excel or CSV file");
    }
  };
  

  if (selectedExcelFile) {
    return (
      <SelectExelRows 
        width={width} 
        height={uploadBoxHeight} 
        file={selectedExcelFile} 
        onSelectionsChange={onSelectionsChange}
        onUnitChange={onUnitChange}  // ✅ Pass unit change function to SelectExelRows
      />
    );
  }

  return (
    <div
      style={{
        ...styles.uploadBox,
        width: `${width}px`,
        height: `${uploadBoxHeight}px`,
        borderColor: dragActive ? "#007bff" : "#ccc",
      }}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={openFileDialog}
    >
      <input
        type="file"
        id={`fileInput-excel-${width}`} // ✅ Unique ID for Excel
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      <div style={styles.titleContainer}>
        <h3 style={styles.title}>Upload Excel or CSV</h3> {/* ✅ Updated title */}
      </div>

      <div style={styles.textContainer}>
        {errorExcel ? (
          <p style={styles.errorText}>{errorExcel}</p>
        ) : (
          <p>Drag <b>Excel or CSV</b> file here or <span style={styles.clickText}>click to upload</span></p> // ✅ Updated text
        )}
      </div>
    </div>
  );
}

const styles = {
  uploadBox: {
    border: "2px dashed #ccc",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    textAlign: "center",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "border-color 0.3s",
    backgroundColor: "#f9f9f9",
    fontFamily: "'Times New Roman', sans-serif",
    padding: "10px",
  },
  titleContainer: {
    width: "100%",
    paddingTop: "5px",
    borderBottom: "1px solid #ccc",
    textAlign: "center",
  },
  title: {
    fontSize: "18px",
    fontWeight: "bold",
    fontFamily: "'Times New Roman', sans-serif",
    margin: "0",
  },
  textContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "10px",
  },
  errorText: {
    fontSize: "14px",
    color: "red",
    fontWeight: "bold",
  },
  clickText: {
    fontWeight: "bold",
    color: "#007bff",
  },
};

export default UploadExel;
